import { render, staticRenderFns } from "./PostEditWeight.vue?vue&type=template&id=efc757aa"
import script from "./PostEditWeight.vue?vue&type=script&lang=js"
export * from "./PostEditWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports